import { render } from "./LeadView.vue?vue&type=template&id=6da7594f"
import script from "./LeadView.vue?vue&type=script&lang=js"
export * from "./LeadView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__